import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../../components/header'
import Footer from '../../components/footer'
import Whatsapp from '../../components/whatsapp'
import './direito-previdencirio.css'

const DireitoPrevidencirio = (props) => {
  return (
    <div className="direito-previdencirio-container10">
      <Helmet>
        <title>
          Direito-Previdencirio - Adv. Wanderson H Cavalari - Cuiabá
        </title>
        <meta
          name="description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
        <meta
          property="og:title"
          content="Direito-Previdencirio - Adv. Wanderson H Cavalari - Cuiabá"
        />
        <meta
          property="og:description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
      </Helmet>
      <div className="direito-previdencirio-container11">
        <main className="direito-previdencirio-container12">
          <div className="direito-previdencirio-container13">
            <Header rootClassName="headerroot-class-name9"></Header>
            <div className="direito-previdencirio-container14">
              <div className="direito-previdencirio-frame46">
                <span className="direito-previdencirio-text100">
                  ÁREA DE ATUAÇÃO
                </span>
                <span className="direito-previdencirio-text101">Direito</span>
                <span className="direito-previdencirio-text102">
                  Previdenciário
                </span>
                <span className="direito-previdencirio-text103">
                  Direito previdenciário envolve a proteção dos direitos
                  sociais, garantindo benefícios como aposentadoria, pensões e
                  auxílios, e representa segurados em processos administrativos
                  e judiciais para assegurar seus direitos previdenciários.
                </span>
              </div>
              <div className="direito-previdencirio-container15">
                <span className="direito-previdencirio-text104">
                  <span>Fale Comigo</span>
                </span>
                <span className="direito-previdencirio-text106 Content">
                  Quer saber mais sobre esta área de atuação? Mande-me uma
                  mensagem para introduzirmos esta questão
                </span>
                <iframe
                  src="https://whc-dun.vercel.app/email"
                  scrolling="no"
                  className="direito-previdencirio-iframe"
                ></iframe>
              </div>
            </div>
          </div>
          <div className="direito-previdencirio-container16">
            <div className="direito-previdencirio-container17">
              <div className="direito-previdencirio-container18">
                <span className="direito-previdencirio-text107 Head">
                  BPC LOAS - Idosos - Doenças - Autismo
                </span>
                <span className="direito-previdencirio-text108">
                  <span>
                    A Lei Orgânica da Assistência Social (LOAS) prevê o
                    Benefício de Prestação Continuada (BPC), que é destinado a
                    idosos e pessoas com deficiência em situação de
                    vulnerabilidade socioeconômica. Aqui estão algumas
                    informações sobre como esse benefício pode ser aplicado em
                    casos específicos:
                  </span>
                  <br></br>
                </span>
              </div>
              <div className="direito-previdencirio-frame861">
                <div className="direito-previdencirio-container19">
                  <div className="direito-previdencirio-container20">
                    <span className="direito-previdencirio-text111">
                      Idosos
                    </span>
                    <span className="direito-previdencirio-text112">
                      <span>
                        1. Critérios de Elegibilidade: Idosos com 65 anos ou
                        mais que não possuam meios de prover a própria
                        subsistência ou tê-la provida pela família.
                      </span>
                      <br></br>
                      <span>
                        2. Avaliação Socioeconômica: O requerente deve passar
                        por uma avaliação socioeconômica para comprovar a
                        situação de vulnerabilidade.
                      </span>
                      <br></br>
                      <span>
                        3. Benefício: O BPC para idosos é no valor de um salário
                        mínimo vigente e não gera 13º salário.
                      </span>
                      <br></br>
                      <span>
                        4. Renovação: A cada dois anos, é necessário realizar
                        uma revisão do benefício para comprovar que os
                        requisitos continuam sendo atendidos.
                      </span>
                      <br></br>
                      <br></br>
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/prev-idosos.jpg"
                    loading="eager"
                    className="direito-previdencirio-image10"
                  />
                </div>
                <div className="direito-previdencirio-container21">
                  <div className="direito-previdencirio-container22">
                    <span className="direito-previdencirio-text122">
                      Pessoas com Deficiência
                    </span>
                    <span className="direito-previdencirio-text123">
                      <span>
                        1. Critérios de Elegibilidade: Pessoas com deficiência
                        que comprovem impedimentos de longo prazo de natureza
                        física, mental, intelectual ou sensorial, que os
                        impossibilitem de participar plenamente na sociedade.
                      </span>
                      <br></br>
                      <span>
                        2. Avaliação Médica e Social: É necessário apresentar
                        laudos médicos que atestem a deficiência e passar por
                        uma avaliação social para comprovar a situação de
                        vulnerabilidade.
                      </span>
                      <br></br>
                      <span>
                        3. Benefício: O BPC para pessoas com deficiência é no
                        valor de um salário mínimo vigente e pode gerar 13º
                        salário.
                      </span>
                      <br></br>
                      <span>
                        4. Renovação: Assim como para os idosos, a revisão do
                        benefício deve ser realizada a cada dois anos.
                      </span>
                      <br></br>
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/prev-deficiencia.jpg"
                    loading="eager"
                    className="direito-previdencirio-image11"
                  />
                </div>
                <div className="direito-previdencirio-container23">
                  <div className="direito-previdencirio-container24">
                    <span className="direito-previdencirio-text132">
                      Autismo
                    </span>
                    <span className="direito-previdencirio-text133">
                      <span>
                        1. Elegibilidade: Pessoas com autismo podem ser
                        elegíveis para o BPC se comprovarem que a condição de
                        autismo causa uma incapacidade que os impeça de prover o
                        próprio sustento.
                      </span>
                      <br></br>
                      <span>
                        2. Documentação Médica e Social: É necessário apresentar
                        laudos médicos que comprovem o diagnóstico de autismo e
                        passar pela avaliação social para comprovar a situação
                        de vulnerabilidade socioeconômica.
                      </span>
                      <br></br>
                      <span>
                        3. Benefício: Se todos os critérios forem atendidos, a
                        pessoa com autismo pode receber o BPC nos mesmos termos
                        que outras pessoas com deficiência.
                      </span>
                      <br></br>
                      <br></br>
                      <span>
                        Para dar entrada no benefício, é necessário comparecer
                        ao Instituto Nacional do Seguro Social (INSS) ou a uma
                        agência da assistência social do município com a
                        documentação necessária e solicitar a análise do pedido.
                        Se o benefício for negado, é possível recorrer da
                        decisão administrativamente.
                      </span>
                      <br></br>
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/prev-autismo.jpg"
                    loading="eager"
                    className="direito-previdencirio-image12"
                  />
                </div>
              </div>
              <div className="direito-previdencirio-container25">
                <span className="Head direito-previdencirio-text143">
                  Revisão de Aposentadorias.
                </span>
                <span className="direito-previdencirio-text144">
                  No direito brasileiro, as ações relacionadas a aposentadorias
                  geralmente envolvem o Instituto Nacional do Seguro Social
                  (INSS) e visam garantir os direitos previdenciários dos
                  trabalhadores. Aqui estão algumas das principais ações
                  relacionadas à aposentadoria:
                </span>
              </div>
              <div className="direito-previdencirio-frame862">
                <div className="direito-previdencirio-container26">
                  <img
                    alt="image"
                    src="/prev-aposentadoria-tempo.jpg"
                    loading="eager"
                    className="direito-previdencirio-image13"
                  />
                  <div className="direito-previdencirio-container27">
                    <span className="direito-previdencirio-text145">
                      Aposentadoria por Tempo de Contribuição:
                    </span>
                    <span className="direito-previdencirio-text146">
                      <span>
                        1. Reconhecimento do Tempo de Contribuição: Muitas
                        vezes, trabalhadores precisam entrar com ação para que o
                        INSS reconheça períodos de trabalho não registrados ou
                        informados de forma inadequada.
                      </span>
                      <br></br>
                      <span>
                        2. Cálculo do Tempo de Contribuição: Em casos onde há
                        discordância sobre o tempo de contribuição computado
                        pelo INSS, é possível entrar com ação para revisão e
                        recálculo.
                      </span>
                      <br></br>
                      <span>
                        3. Aposentadoria Integral ou Proporcional: Dependendo do
                        tempo de contribuição, o trabalhador pode ter direito à
                        aposentadoria integral ou proporcional, e é necessário
                        verificar se os cálculos do INSS estão corretos.
                      </span>
                      <br></br>
                      <span>
                        4. Revisão da Aposentadoria: Em alguns casos, é possível
                        entrar com ação de revisão da aposentadoria para buscar
                        correções ou aumentos nos valores pagos.
                      </span>
                      <br></br>
                    </span>
                  </div>
                </div>
                <div className="direito-previdencirio-container28">
                  <img
                    alt="image"
                    src="/prev-aposentadoria-idade.jpg"
                    loading="eager"
                    className="direito-previdencirio-image14"
                  />
                  <div className="direito-previdencirio-container29">
                    <span className="direito-previdencirio-text155">
                      Aposentadoria por Idade
                    </span>
                    <span className="direito-previdencirio-text156">
                      <span>
                        1. Comprovação da idade: Em casos onde há dúvidas sobre
                        a idade do segurado, é possível entrar com ação para
                        comprovar a idade e garantir o direito à aposentadoria
                        por idade.
                      </span>
                      <br></br>
                      <span>
                        2. Cálculo dos Benefícios: Assim como na aposentadoria
                        por tempo de contribuição, é importante verificar se os
                        cálculos do INSS estão corretos para garantir o valor
                        adequado do benefício.
                      </span>
                      <br></br>
                      <br></br>
                    </span>
                  </div>
                </div>
                <div className="direito-previdencirio-container30">
                  <img
                    alt="image"
                    src="/prev-aposentadoria-invalidez.jpg"
                    loading="eager"
                    className="direito-previdencirio-image15"
                  />
                  <div className="direito-previdencirio-container31">
                    <span className="direito-previdencirio-text162">
                      Aposentadoria por Invalidez
                    </span>
                    <span className="direito-previdencirio-text163">
                      <span>
                        1. Comprovação da Incapacidade: Em casos de
                        aposentadoria por invalidez, é necessário comprovar a
                        incapacidade para o trabalho por meio de laudos médicos
                        e avaliação do INSS.
                      </span>
                      <br></br>
                      <span>
                        2. Perícia Médica: Caso haja discordância entre o laudo
                        médico do segurado e a avaliação do INSS, é possível
                        entrar com ação para contestar a decisão e buscar o
                        reconhecimento da invalidez.
                      </span>
                      <br></br>
                    </span>
                  </div>
                </div>
                <div className="direito-previdencirio-container32">
                  <img
                    alt="image"
                    src="/prev-aposentadoria-especial.jpg"
                    loading="eager"
                    className="direito-previdencirio-image16"
                  />
                  <div className="direito-previdencirio-container33">
                    <span className="direito-previdencirio-text168">
                      Aposentadoria Especial
                    </span>
                    <span className="direito-previdencirio-text169">
                      <span>
                        1. Comprovação da Exposição a Agentes Nocivos: Para
                        aposentadoria especial, é necessário comprovar a
                        exposição a agentes nocivos à saúde durante a atividade
                        laboral, como ruído, calor, produtos químicos, entre
                        outros.
                      </span>
                      <br></br>
                      <span>
                        2 .Reconhecimento do Direito: Em casos onde o INSS nega
                        o reconhecimento da aposentadoria especial, é possível
                        entrar com ação para contestar a decisão e buscar o
                        reconhecimento do direito.
                      </span>
                      <br></br>
                    </span>
                  </div>
                </div>
              </div>
              <div className="direito-previdencirio-container34">
                <span className="Head direito-previdencirio-text174">
                  Benefícios negados
                </span>
                <span className="direito-previdencirio-text175">
                  Uma ação de revisão de benefícios negados é uma medida legal
                  tomada por um segurado do Instituto Nacional do Seguro Social
                  (INSS) que teve seu pedido de benefício negado. Essa ação visa
                  contestar a decisão do INSS e buscar o reconhecimento do
                  direito ao benefício devido.
                </span>
              </div>
              <div className="direito-previdencirio-container35">
                <span className="Head direito-previdencirio-text176">
                  Auxílios em geral - acidente - reclusão - doença
                </span>
                <span className="direito-previdencirio-text177">
                  As ações relacionadas aos auxílios, como auxílio-acidente,
                  auxílio-reclusão e auxílio-doença, visam garantir a proteção
                  social e assistencial aos trabalhadores e seus dependentes em
                  situações específicas. Aqui estão algumas informações sobre
                  cada um desses auxílios e as possíveis ações relacionadas:
                </span>
              </div>
              <div className="direito-previdencirio-frame863">
                <div className="direito-previdencirio-container36">
                  <div className="direito-previdencirio-container37">
                    <span className="direito-previdencirio-text178">
                      Auxílio-Acidente
                    </span>
                    <span className="direito-previdencirio-text179">
                      <span>
                        1. Definição: É um benefício pago ao trabalhador
                        segurado do INSS que sofreu um acidente e, apesar de ter
                        se recuperado parcialmente, ficou com sequelas que
                        reduzem sua capacidade para o trabalho.
                      </span>
                      <br></br>
                      <span>
                        2. Comprovação da Sequela: Para requerer o
                        auxílio-acidente, é necessário apresentar laudos médicos
                        e documentação que comprovem as sequelas decorrentes do
                        acidente.
                      </span>
                      <br></br>
                      <br></br>
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/prev-auxilio-acidente.jpg"
                    loading="eager"
                    className="direito-previdencirio-image17"
                  />
                </div>
                <div className="direito-previdencirio-container38">
                  <div className="direito-previdencirio-container39">
                    <span className="direito-previdencirio-text185">
                      Auxílio-Reclusão
                    </span>
                    <span className="direito-previdencirio-text186">
                      <span>
                        1. Definição: É um benefício pago aos dependentes de
                        segurados do INSS que foram recolhidos à prisão em
                        regime fechado ou semiaberto.
                      </span>
                      <br></br>
                      <span>
                        2. Comprovação da Reclusão: Para requerer o
                        auxílio-reclusão, é necessário apresentar documentação
                        que comprove o recolhimento do segurado à prisão.
                      </span>
                      <br></br>
                      <br></br>
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/prev-auxilio-reclusao.jpg"
                    loading="eager"
                    className="direito-previdencirio-image18"
                  />
                </div>
                <div className="direito-previdencirio-container40">
                  <div className="direito-previdencirio-container41">
                    <span className="direito-previdencirio-text192">
                      Auxílio-Doença
                    </span>
                    <span className="direito-previdencirio-text193">
                      <span>
                        1. Definição: É um benefício pago ao trabalhador
                        segurado do INSS que está temporariamente incapacitado
                        para o trabalho devido a doença ou acidente não
                        relacionado ao trabalho.
                      </span>
                      <br></br>
                      <span>
                        2. Comprovação da Incapacidade: Para requerer o
                        auxílio-doença, é necessário apresentar laudos médicos e
                        documentação que comprovem a incapacidade para o
                        trabalho.
                      </span>
                      <br></br>
                      <br></br>
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/prev-auxilio-doenca.jpg"
                    loading="eager"
                    className="direito-previdencirio-image19"
                  />
                </div>
                <div className="direito-previdencirio-container42">
                  <span className="Head direito-previdencirio-text199">
                    Planejamento Previdenciário
                  </span>
                  <span className="direito-previdencirio-text200">
                    <span>
                      O planejamento previdenciário é uma estratégia essencial
                      para garantir uma aposentadoria mais tranquila e maximizar
                      os benefícios previdenciários disponíveis.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <br></br>
                    <span>
                      Um planejamento previdenciário bem elaborado pode
                      contribuir significativamente para uma aposentadoria mais
                      confortável e tranquila, garantindo que você aproveite ao
                      máximo os benefícios disponíveis e esteja preparado para
                      os desafios financeiros que possam surgir ao longo do
                      caminho.
                    </span>
                    <br></br>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <Footer rootClassName="footerroot-class-name3"></Footer>
          <Whatsapp></Whatsapp>
        </main>
      </div>
    </div>
  )
}

export default DireitoPrevidencirio
